// extracted by mini-css-extract-plugin
module.exports = {"limitedText":"ReadFullNote_limitedText__2kS2d","overflowing":"ReadFullNote_overflowing__2szbl"};